<script setup lang="ts">
import { onMounted } from 'vue'

import UpdatePrompt from '@/components/UpdatePrompt.vue'
import { connect } from '@/lib/db'

onMounted(() => {
  // Failing to reach the database is a state, not an error: the app is meant
  // to open and show what it has.
  connect().catch(() => {})
})
</script>

<template>
  <div class="flex min-h-dvh flex-col">
    <RouterView />
    <UpdatePrompt />
  </div>
</template>
